import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/agro_exporter/${agro_exporter_id}`
    );
  },
  fetchContainer(customer_id, agro_exporter_id, container_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/container/${agro_exporter_id}/${container_id}`
    );
  },
  fetchProducers(customer_id, agro_exporter_id, container_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/producers/${agro_exporter_id}/${container_id}`
    );
  },
  downloadExportationAttachment(customer_id, exportation_attachment_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/download_exportation_attachment/${exportation_attachment_id}`,
      { responseType: "blob" }
    );
  },
  downloadContainerAttachment(customer_id, container_attachment_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/download_container_attachment/${container_attachment_id}`,
      { responseType: "blob" }
    );
  },
  packingListByPalletRepXlsx(customer_id, container_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/packing_list_by_pallet_rep_xlsx/${container_id}`,
      { responseType: "blob" }
    );
  },
  packingListByProducerRepXlsx(customer_id, container_id) {
    return RequesterV1.get(
      `customer/query/basic_containers/show_container/${customer_id}/packing_list_by_producer_rep_xlsx/${container_id}`,
      { responseType: "blob" }
    );
  }
};
